<template>
  <div ref="container" :class="containerClass" v-bind="$attrs">
    <rs-alert-message
      v-for="msg of messages"
      :key="msg.id"
      :message="msg"
      @close="remove($event)"
      :template="$slots.message || $slots.payload"
    />
  </div>
</template>

<script>
  import RsAlertEventBus from '../events'
  import RsAlertMessage from './RsAlertMessage'
  import { UniqueComponentId } from '../../../utils'

  let messageIdx = 0

  export default {
    name: 'RsAlert',

    components: { RsAlertMessage },

    inheritAttrs: false,

    props: {
      group: {
        type: String,
        default: null
      },

      breakpoints: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
        messages: []
      }
    },

    styleElement: null,

    mounted() {
      RsAlertEventBus.on('add', this.onAdd)
      RsAlertEventBus.on('remove-group', this.onRemoveGroup)
      RsAlertEventBus.on('remove-all-groups', this.onRemoveAllGroups)
      if (this.breakpoints) this.createStyle()
    },

    beforeUnmount() {
      this.destroyStyle()
      RsAlertEventBus.off('add', this.onAdd)
      RsAlertEventBus.off('remove-group', this.onRemoveGroup)
      RsAlertEventBus.off('remove-all-groups', this.onRemoveAllGroups)
    },

    methods: {
      add(message) {
        if (message.id == null) {
          message.id = messageIdx++
        }
        this.messages = [...this.messages, message]
      },
      remove(message) {
        let index = -1
        for (let i = 0; i < this.messages.length; i++) {
          if (this.messages[i] === message) {
            index = i
            break
          }
        }
        this.messages.splice(index, 1)
      },
      onAdd(message) {
        if (this.group === message.group) {
          this.add(message)
        }
      },
      onRemoveGroup(group) {
        if (this.group === group) {
          this.messages = []
        }
      },
      onRemoveAllGroups() {
        this.messages = []
      },
      onEnter() {
        this.$refs.container.setAttribute(this.attributeSelector, '')
      },
      createStyle() {
        if (!this.styleElement) {
          this.styleElement = document.createElement('style')
          this.styleElement.type = 'text/css'
          document.head.appendChild(this.styleElement)
          let innerHTML = ''
          for (const breakpoint in this.breakpoints) {
            let breakpointStyle = ''
            for (const styleProp in this.breakpoints[breakpoint]) {
              breakpointStyle +=
                styleProp + ':' + this.breakpoints[breakpoint][styleProp] + '!important;'
            }
            innerHTML += `
                        @media screen and (max-width: ${breakpoint}) {
                            .rs-alert[${this.attributeSelector}] {
                                ${breakpointStyle}
                            }
                        }
                    `
          }
          this.styleElement.innerHTML = innerHTML
        }
      },
      destroyStyle() {
        if (this.styleElement) {
          document.head.removeChild(this.styleElement)
          this.styleElement = null
        }
      }
    },

    computed: {
      containerClass() {
        return ['rs-alert-group']
      },
      attributeSelector() {
        return UniqueComponentId()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .rs-alert-group {
    .rs-alert {
      margin-top: 15px;
    }
  }
</style>
